import { Box, FormControl, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import React from 'react';

import { useDispatch } from 'react-redux';
import { switchPrepaySchedule } from '../../../../actions/prepaySettings/PrepaySettingsActions';
import ScheduleTable from '../../../../components/Common/ScheduleTable';
import { PREPAYMENT_ACCEPTANCE_SCHEDULE_VARIANTS } from '../../../entities/prepaySettings';

import { usePrepayAcceptanceSchedule } from '../model';

const useStyles = makeStyles((theme) => ({
  fieldRow: {
    marginBottom: theme.spacing(3),
  },
  selectFormControl: {
    minWidth: '100%',
  },
}));

export const PrepayAcceptanceSchedule = () => {
  const classes = useStyles();
  const settings = usePrepayAcceptanceSchedule();
  const dispatch = useDispatch();

  const activeType =
    settings.isActiveRestaurantSchedule === undefined
      ? ''
      : PREPAYMENT_ACCEPTANCE_SCHEDULE_VARIANTS[settings.isActiveRestaurantSchedule ? 0 : 1].value;

  const handleSwitchSchedule = (e: React.ChangeEvent<{ value: unknown }>) => {
    dispatch(
      switchPrepaySchedule(e.target.value === PREPAYMENT_ACCEPTANCE_SCHEDULE_VARIANTS[0].value),
    );
  };

  return (
    <>
      <Box className={classes.fieldRow}>
        <FormControl className={classes.selectFormControl}>
          <InputLabel id="prepayment-acceptance-schedule-label">
            График приема предоплаты
          </InputLabel>
          <Select
            labelId="prepayment-acceptance-schedule-label"
            name="prepaymentAcceptanceSchedule"
            value={activeType}
            onChange={handleSwitchSchedule}
          >
            {PREPAYMENT_ACCEPTANCE_SCHEDULE_VARIANTS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {activeType === PREPAYMENT_ACCEPTANCE_SCHEDULE_VARIANTS[1].value && (
        <Box className={classes.fieldRow}>
          <ScheduleTable type="prepay" restaurantWorkTimes={settings.workTimes} />
        </Box>
      )}
    </>
  );
};
